import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  a: 'Al instante por mail. Revisá Promociones o Spam si no lo ves en tu bandeja principal. En menos de 5 minutos tenés todo descargado.'
}, {
  q: '2 — ¿Sirve para mi provincia o solo para Buenos Aires?',
  a: 'Sirve para todo el país. Está alineado con los contenidos del currículo nacional argentino de Química para secundaria.'
}, {
  q: '3 — ¿Es editable? ¿Puedo modificarlo?',
  a: 'Es en formato PDF de alta calidad. Podés imprimirlo, proyectarlo en clase o usarlo en pantalla. Algunos elementos son editables.'
}, {
  q: '4 — ¿Los 6 bonos están en todas las ofertas?',
  a: 'Sí. Los 6 bonos están incluidos en los 3 packs sin costo adicional.'
}, {
  q: '5 — ¿Puedo comprar el Pack Iniciación ahora y el resto después?',
  a: 'Sí. Podés empezar con cualquier pack y luego acceder al resto. Sin embargo el Pack Completo es la opción más conveniente por precio.'
}, {
  q: '6 — ¿Funciona si mis alumnos tienen distintos niveles?',
  a: 'Sí. Las actividades están secuenciadas de menor a mayor complejidad exactamente para eso. Cada cuadernillo tiene actividades de nivel inicial, básico, intermedio y avanzado.'
}, {
  q: '7 — ¿Sirve para cursos difíciles o con poca motivación?',
  a: 'Sí. El Bono 3 de Química Orgánica y Vida Cotidiana fue diseñado especialmente para enganchar a los alumnos que dicen que odian la química.'
}, {
  q: '8 — ¿Está actualizado al currículo vigente?',
  a: 'Sí. Está alineado con los NAP y los diseños curriculares actuales de Química para secundaria en Argentina.'
}, {
  q: '9 — ¿Tiene garantía real?',
  a: 'Total. 7 días de garantía sin preguntas. Si no te convence te devolvemos el 100% del dinero.'
}, {
  q: '10 — ¿Qué diferencia tiene este MegaPack con otros materiales que vi?',
  a: 'Que fue creado desde el aula argentina para el aula argentina. Incluye rúbricas integradas por actividad, experiencias de laboratorio con guías completas, modelos de partículas en color y proyectos listos para la muestra anual. No es material genérico copiado de internet.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <h2 className="text-4xl font-black text-center text-brand-dark mb-12" data-id="element-84">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-85">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-86">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-87">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-88">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-orange flex-shrink-0" data-id="element-89" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-90" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-91">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}